module.exports = __webpack_public_path__ + "static/media/sasa.ff80e28a.png";